export default __webpack_public_path__ + "static/media/print-style-1.a627338a.jpg";